// extracted by mini-css-extract-plugin
export default {"Wrapper":"Input_Wrapper__BcCs2","Title":"Input_Title__VXY0n","Input":"Input_Input__8hdy0","InputCheckbox":"Input_InputCheckbox__Dm5lt","Checkbox":"Input_Checkbox__FMaJz"};